<template>

  <el-row v-if="showLocal" class="bg-bordered">
    <el-col :span="24">
      <el-menu
        v-model="menu"
        :default-active="menu"
        mode="horizontal"
        @select="select"
        background-color="#F2F6FC"
        text-color="#606266"
        active-text-color="#409EFF">
        <el-menu-item index="all"><i class="fa fa-sitemap"></i>&nbsp;<span v-if="isDesktop"> All</span> <b v-if="lst.sitesTotal">({{lst.sitesTotal}})</b></el-menu-item>
        <el-menu-item index="active" v-if="lst.sitesActive"><i class="fa fa-dot-circle text-primary"></i>&nbsp;<span v-if="isDesktop"> Active&nbsp;</span><b v-if="lst.sitesActive">({{lst.sitesActive}})</b></el-menu-item>
        <el-menu-item index="new" v-if="lst.sitesNew"><i class="fa fa-plus-square text-success"></i>&nbsp;<span v-if="isDesktop"> New&nbsp;</span><b v-if="lst.sitesNew">({{lst.sitesNew}})</b></el-menu-item>
        <el-menu-item index="exclusive" v-if="lst.sitesExclusive"><i class="fa fa-exclamation text-black"></i>&nbsp;<span v-if="isDesktop"> Exclusive&nbsp;</span><b v-if="lst.sitesExclusive">({{lst.sitesExclusive}})</b></el-menu-item>
        <el-menu-item index="candidate" v-if="lst.sitesCandidate"><i class="fa fa-map-pin text-warning"></i>&nbsp;<span v-if="isDesktop"> Candidate&nbsp;</span><b v-if="lst.sitesCandidate">({{lst.sitesCandidate}})</b></el-menu-item>
        <el-menu-item index="land-only" v-if="lst.sitesLandOnly"><i class="fa fa-map text-info"></i>&nbsp;<span v-if="isDesktop"> Land Only&nbsp;</span><b v-if="lst.sitesLandOnly">({{lst.sitesLandOnly}})</b></el-menu-item>
        <el-menu-item index="temporary" v-if="lst.sitesTemporary"><i class="fa fa-clock text-info"></i>&nbsp;<span v-if="isDesktop"> Temporary&nbsp;</span><b v-if="lst.sitesTemporary">({{lst.sitesTemporary}})</b></el-menu-item>
        <el-menu-item index="dismantled" v-if="lst.sitesDismantled"><i class="fa fa-bolt text-danger"></i>&nbsp;<span v-if="isDesktop"> Dismantled&nbsp;</span><b v-if="lst.sitesDismantled">({{lst.sitesDismantled}})</b></el-menu-item>
        <el-menu-item index="sold" v-if="lst.sitesSold"><i class="fa fa-money-bill-wave text-danger"></i>&nbsp;<span v-if="isDesktop"> Sold&nbsp;</span><b v-if="lst.sitesSold">({{lst.sitesSold}})</b></el-menu-item>
      </el-menu>
    </el-col>
  </el-row>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'
Vue.use(VueEvents)

import {SITETABLE_VIEW_EVENT} from '@/components/Data'

export default {

  props: {

    view: {
      type: String,
      required: true,
      default: 'all'
    },

    show: {
      type: Boolean,
      default: true
    },

    stats: {
      type: Object,
      default: {}
    }

  },



  watch: {

    show: function (s) {
      this.showLocal = s
    },

    '$route.params': {
      handler: function (p) {

        if (p.view) {
          this.menu = p.view.toLowerCase()
          this.$events.fire(SITETABLE_VIEW_EVENT, this.menu)
        } else {
          this.menu = 'all'
        }
      },
      deep: true,
      immediate: true
    }

  },

  methods: {

    select (view) {
      this.menu = view
      this.$events.fire(SITETABLE_VIEW_EVENT, this.menu)
    }

  },

  data () {

    return {
      menu: this.view.toLowerCase(),
      showLocal: this.show,
      lst: this.stats
      }
    },

 created () {
   if (!this.lst) {
     this.lst = this.getStats(this.org().id, true)
   }
 }

}
</script>



// WEBPACK FOOTER //
// SiteMenu.vue?20e7d067